module.exports = __webpack_public_path__ + "static/media/queuetube.03568253.svg";